import { useState } from "react";
import { parseInvoiceOrQuote, type ParsedDoc } from "../lib/invoice-parser";
import { track } from "../lib/analytics";

export default function InvoiceUpload({
  onParsed
}: { onParsed: (doc: ParsedDoc) => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFile = async (file?: File) => {
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const parsed = await parseInvoiceOrQuote(file);
      onParsed(parsed);
      
      // Track successful document parsing
      track("ai_doc_parsed", { 
        amountAED: parsed.amountAED,
        issuer: parsed.issuer,
        hasLineItems: !!parsed.lineItems?.length 
      });
    } catch (e: any) {
      setError("Sorry, we couldn't read that file. Try a clear PDF/JPG/PNG.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border p-3">
      <div className="text-sm font-medium mb-2">Have an invoice or quote? (Optional)</div>
      <input
        type="file"
        accept="application/pdf,image/*"
        onChange={(e) => handleFile(e.target.files?.[0])}
        className="text-sm"
      />
      {busy && <div className="text-xs text-gray-500 mt-2">Reading document…</div>}
      {error && <div className="text-xs text-red-600 mt-2">{error}</div>}
      <div className="text-[11px] text-gray-500 mt-2">
        We parse invoice totals only. Don't upload sensitive medical records. See Privacy.
        <br />
        We'll extract amount & due date to tailor plans.
      </div>
    </div>
  );
}